module.exports = __webpack_public_path__ + "img/workNewsCover5.44e132de.png";